import React, { useEffect, useState, useMemo } from "react";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import { myInternshipsList } from "../user.api";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Pagination from "../../../components/page/companyDirectory/companyPagination";
import BreadCrumpBack from "../../../components/navigator/back";
import "./style.css";

const PageSize = 9;

export default function RegisteredInternships(props) {
  const history = useHistory();
  const [searchData, setSearchData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    fetchInternships();
  }, []);

  const fetchInternships = () => {
    setIsLoading(true);
    myInternshipsList()
      .then((res) => {
        if (res?.success) {
          // Flatten application and proposals to show each preference as a card
          const flattenedData = [];
          (res.data || []).forEach(app => {
            if (app.proposals && app.proposals.length > 0) {
              app.proposals.forEach(prop => {
                flattenedData.push({
                  ...prop,
                  application_id: app.application_id,
                  full_name: app.full_name,
                  email: app.email,
                  phone_no: app.phone_no,
                  app_created_at: app.created_at
                });
              });
            } else {
              // Application without specific proposals (fallback case)
              flattenedData.push({
                application_id: app.application_id,
                full_name: app.full_name,
                email: app.email,
                phone_no: app.phone_no,
                app_created_at: app.created_at,
                internship_title: "General Registration",
                company_name: "KSPACE Internship Pool",
                status: "Pending"
              });
            }
          });
          setSearchData(flattenedData);
        } else {
          setSnackMessage("Failed to load registered internships");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching internships:", error);
        setSnackMessage("Error loading registered internships");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const mainData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return searchData.slice(firstPageIndex, lastPageIndex);
  }, [searchData, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
      case "ranking_confirmed":
        return "approved";
      case "rejected":
        return "rejected";
      case "pending":
      default:
        return "pending";
    }
  };

  const handleViewDetails = (id) => {
    history.push(`/internship-applied/${id}`);
  };

  return (
    <div className="registered-internships-page">
      <Loader open={isLoading} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="dash-banner-minimal">
        <div className="tit-txt">
          {props.state.language === "ma" ? "രജിസ്റ്റർ ചെയ്ത ഇന്റേൺഷിപ്പുകൾ" : "Registered Internships"}
        </div>
      </div>

      <BreadCrumpBack />

      <div className="container p-50">
        <div className="d-flex justify-content-between align-items-center mb-5">
           <h5 className="fw-bold text-dark">
             {props.state.language === "ma" ? "എന്റെ ഇന്റേൺഷിപ്പ് രജിസ്ട്രേഷനുകൾ" : "My Internship Registrations"}
           </h5>
        </div>

        {mainData && mainData.length > 0 ? (
          <>
            <div className="row">
              {mainData.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div className="card internship-minimal-card h-100 shadow-sm border-0">
                    <div className="card-body d-flex flex-column">
                      <div className="d-flex justify-content-between align-items-start mb-3">
                         <span className={`status-badge-minimal ${getStatusClass(item.status)}`}>
                            {item.status || "Pending"}
                         </span>
                         <span className="text-muted small fw-bold">#{item.application_id}</span>
                      </div>
                      
                      <h4 className="card-title h6 mb-1 text-black">
                        {item.internship_title || item.internship_request?.internship_discipline || "Internship Program"}
                      </h4>
                      <div className="company-name text-muted small mb-3">
                         {item.company_name || item.internship_request?.company?.company_name || "KSPACE Community"}
                      </div>

                      <div className="internship-minimal-meta mt-auto">
                        <div className="meta-item">
                           <span className="label">Order</span>
                           <span className="value">#{item.preference_order || "1"}</span>
                        </div>
                        <div className="meta-item">
                           <span className="label">Applied Date</span>
                           <span className="value">{moment(item.app_created_at).format("DD-MMM-YYYY")}</span>
                        </div>
                      </div>

                      <button
                        className="btn btn-sm btn-minimal-outline mt-4 w-100"
                        onClick={() => handleViewDetails(item.application_id)}
                      >
                        {props.state.language === "ma" ? "വിശദാംശങ്ങൾ കാമിക്യുക" : "View Details"}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {Math.ceil(searchData.length / PageSize) > 1 && (
              <div className="d-flex justify-content-center mt-5">
                <Pagination
                  currentPage={currentPage}
                  totalCount={searchData.length}
                  pageSize={PageSize}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-5 bg-white rounded-4 border border-light">
             <img src="/assets/img/empty-in.svg" alt="Empty" style={{ maxWidth: '120px' }} className="mb-3 opacity-25" />
             <p className="text-muted small">
               {props.state.language === "ma" ? "യാതൊരു രജിസ്ട്രേഷനുകളും കണ്ടുകിട്ടിയില്ല" : "No registered internships found"}
             </p>
          </div>
        )}
      </div>
    </div>
  );
}
